import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { SunriseIcon } from 'lucide-react';
export function ProofSection() {
  return <section className="py-24 bg-navy-900" data-id="element-291">
      <div className="max-w-3xl mx-auto px-6" data-id="element-292">
        <FadeIn data-id="element-293">
          <div className="bg-navy-800 border border-gold-500/20 p-10 md:p-14 rounded-sm text-center relative" data-id="element-294">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-navy-900 p-3 rounded-full border border-gold-500/20" data-id="element-295">
              <SunriseIcon className="w-8 h-8 text-gold-400" data-id="element-296" />
            </div>

            <h3 className="text-xl text-gold-400 font-serif uppercase tracking-widest mb-8 mt-4" data-id="element-297">
              Lo que cambia en 7 días
            </h3>

            <p className="text-2xl md:text-3xl font-serif leading-relaxed text-cream italic" data-id="element-298">
              "Notarás que la pesadez en los párpados al despertar desaparece,
              la irritabilidad matutina disminuye y, por primera vez en años,
              recordarás lo que es dormir de un tirón hasta que sale el sol."
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}